import { Injectable } from '@angular/core';
import { EstimateDto } from '../dtos/estimate.dto';
import { Estimate } from '../../domain/models/estimate.model';

@Injectable()
export class EstimateMapper {
  public toEstimate(dto: EstimateDto): Estimate {
    return {
      id: dto.ExternalId,
      title: dto.Title ?? null,
      date: dto.Created ?? null,
      total: dto.Total ?? null,
      archived: dto.Archived ?? null,
      status: dto.Status ?? null,
      patientNames: dto.PatientNames,
    };
  }
}
